import React, { Component } from "react";
import Dropdown from "../../../pageBreakup/Dropdown/index";
import IsdCodeDropdown from "../../../pageBreakup/IsdDropDown/index";
import getCountriesList from "../../../../lib/getCountriesList";
import { getCityByCountry, getStateApi } from "../../../../lib/myProfile";
import {
  emailValidation,
  nameValidation,
  noLeadingSpace,
  onlyNumbersRegex, noLeadingSpaceAndOnlyAlphabets
} from "../../../../lib/utils/regex_cheat_sheet";
import { travellerSignup } from "../../../../lib/travellerRegistration";
import Verification from "./verification";
import CustomCarousel from "../../../carousel/theme11/CustomCarousel";
import axios from "axios";
import DatePicker from "../../../calendar/calenderV2";
import { encryptData } from "../../../../lib/crypto/crypto";
class RegisterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originCountries: [],
      stateData: [],
      citiesData: [],
      verification: false,
      tnc: false,
      registerSuccess: false,
      mobileOtp: [],
      emailOtp: [],
      site_id:
        this.props.data?.siteData?.data?.site_id || this.props.data?.site_id,
      isMobile: this.props.data.isMobile,
      registration_token: "",
      mobileTime: 180000,
      emailTime: 180000,
      isLoading: false,
      loading: false,
      commonError: "",
      travellerRegistration: {
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: "",
        country_code: {
          _id: "659bae6115a45d1c587e99b0",
          contry_name: "India",
          contry_code: "IN",
          contry_loc_code: "IND",
          contry_flag: "/shared/api/media/flag/IN.svg",
          contry_isd: "91",
          contry_status: "Active",
          __v: 0,
          createdAt: "2024-01-08T08:12:17.766Z",
          updatedAt: "2024-09-03T11:26:13.029Z",
        },
        dob: "",
        country: "",
        state: "",
        city: "",
        password: "",
        confirmPassword: "",
        title: "",
        gender: "",
        photo: '',
        photoFileName: "",
        accept_terms: false,
      },
      travellerRegistrationErrors: {
        first_name: "",
        last_name: "",
        email: "",
        country_code: "",
        mobile_number: "",
        dob: "",
        country: "",
        state: "",
        city: "",
        gender: "",
        password: {
          passLength: false,
          specialChar: false,
          number: false,
          upperCase: false,
          lowerCase: false,
          message: "",
        },
        confirmPassword: "",
        title: "",
        photo: null,
        terms_accept: "",
      },
    };
    this.mobileInterval = null;
    this.emailInterval = null;
    this.dateInputRef = React.createRef();
    this.formContainerRef = React.createRef();
  }
  setCommonError = (message) => {
    this.setState({ commonError: message });
  };
  setMobileTime = (time) => {
    this.setState({ mobileTime: time });
  };

  setEmailTime = (time) => {
    this.setState({ emailTime: time });
  };

  formatTime = (time) => {
    console.log('formatTime received:', time, 'type:', typeof time);
    const minutes = Math.floor(time / 60000);
    const seconds = Math.floor((time % 60000) / 1000);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  mobileOtpChange = (index, value) => {
    const updatedOtp = [...this.state.mobileOtp];
    updatedOtp[index] = value;
    this.setState({ mobileOtp: updatedOtp });
  };

  emailOtpChange = (index, value) => {
    if (Array.isArray(value)) {
      this.setState({ emailOtp: value });
    } else {
      const updatedOtp = [...this.state.emailOtp];
      updatedOtp[index] = value;
      this.setState({ emailOtp: updatedOtp });
    }
  };

  setVerificationLoading = (loading) => {
    this.setState({ loading: loading });
  };

  componentDidMount() {
    if (this.state.verification) {
      this.setState((p) => ({ ...p, emailOtp: Array(6).fill(''), mobileOtp: Array(6).fill('') }))
    }
    if (this.state.mobileTime > 0) {
      this.mobileInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.mobileTime <= 1000) {
            clearInterval(this.mobileInterval);
            return { mobileTime: 0 };
          }
          return { mobileTime: prevState.mobileTime - 1000 };
        });
      }, 1000);
    }

    if (this.state.emailTime > 0) {
      this.emailInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.emailTime <= 1000) {
            clearInterval(this.emailInterval);
            return { emailTime: 0 };
          }
          return { emailTime: prevState.emailTime - 1000 };
        });
      }, 1000);
    }

    getCountriesList().then((resp) => {
      let countryList = [];
      if (resp?.data?.length > 0) {
        resp?.data.map((item) => {
          countryList.push({
            ...item,
            id: item.contry_code,
            label: item.contry_name,
            value: item.contry_name,
            isdCode: item.contry_isd,
            countryCode: item.contry_code,
            flag: item.contry_flag,
            countryFlag: item.contry_flag,
            countryName: item.contry_name,
            code: item.contry_code,
          });
        });
      }
      this.setState({ originCountries: countryList });
    });
  }

  componentWillUnmount() {
    clearInterval(this.mobileInterval);
    clearInterval(this.emailInterval);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.verification !== this.state.verification && !this.state.verification) {
      this.setState({ emailOtp: [], mobileOtp: [] });
    }
    // if (prevState.commonError !== this.state.commonError && this.state.commonError!== '') {
    //   this.setState({ commonError: '' })
    // }
    if (
      prevState.mobileTime !== this.state.mobileTime &&
      this.state.mobileTime > 0
    ) {
      clearInterval(this.mobileInterval);
      this.mobileInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.mobileTime <= 1000) {
            clearInterval(this.mobileInterval);
            return { mobileTime: 0 };
          }
          return { mobileTime: prevState.mobileTime - 1000 };
        });
      }, 1000);
    }
    if (
      prevState.emailTime !== this.state.emailTime &&
      this.state.emailTime > 0
    ) {
      clearInterval(this.emailInterval);
      this.emailInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.emailTime <= 1000) {
            clearInterval(this.emailInterval);
            return { emailTime: 0 };
          }
          return { emailTime: prevState.emailTime - 1000 };
        });
      }, 1000);
    }
  }
  handleChange = (key, val) => {
    const validationRules = {
      first_name: noLeadingSpaceAndOnlyAlphabets,
      last_name: noLeadingSpaceAndOnlyAlphabets,
      email: noLeadingSpace,
      mobile_number: onlyNumbersRegex,
      password: noLeadingSpace,
      confirmPassword: noLeadingSpace,
    };
    if (validationRules[key] && !validationRules[key].test(val) && val !== "") {
      return;
    }

    if (key === 'title') {
    const gender = val.toLowerCase() === 'mr' ? { label: 'Male', value: 'Male', id: 'Male' }
      : (val.toLowerCase() === 'mrs' || val.toLowerCase() === 'ms' ? { label: 'Female', value: 'Female' , id:'Female'} : '');

    this.setState((prevState) => ({
      travellerRegistration: {
        ...prevState.travellerRegistration,
        [key]: val,
        gender: gender,
      },
    }));
  }
    if (key === 'first_name' || key === 'last_name') {
      if (val?.length === 1) {
        this.setState((prevState) => ({
          travellerRegistrationErrors: {
            ...prevState.travellerRegistrationErrors,
            [key]: "Name must be at least 2 characters long.",
          },
        }));
      } else if (val?.length > 1) {
        this.setState((prevState) => ({
          travellerRegistrationErrors: {
            ...prevState.travellerRegistrationErrors,
            [key]: "",
          },
        }));
      }
      this.setState((prevState) => ({
        travellerRegistration: {
          ...prevState.travellerRegistration,
          [key]: val,
        },
      }));
      return

    }
    if (key === 'email') {
      const value = val.trim();

      if (value && !emailValidation.test(value)) {
        this.setState((prevState) => ({
          travellerRegistrationErrors: {
            ...prevState.travellerRegistrationErrors,
            [key]: "Please enter valid Email ID.",
          },
        }));
      } else {
        this.setState((prevState) => ({
          travellerRegistrationErrors: {
            ...prevState.travellerRegistrationErrors,
            [key]: "",
          },
        }));
      }

      this.setState((prevState) => ({
        travellerRegistration: {
          ...prevState.travellerRegistration,
          [key]: val,
        },
      }));

      return;
    }

    if ((key === "password" || key === "confirmPassword") && val) {
      const value = val.trim();
      const passLength = value.length >= 8 && value.length <= 20;
      const specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
      const number = /\d/.test(value);
      const upperCase = /[A-Z]/.test(value);
      const lowerCase = /[a-z]/.test(value);

      this.setState((prevState) => ({
        travellerRegistration: {
          ...prevState.travellerRegistration,
          [key]: value,
        },
        travellerRegistrationErrors: {
          ...prevState.travellerRegistrationErrors,
          password: {
            passLength,
            specialChar,
            number,
            upperCase,
            lowerCase,
            message: key === 'password' ? '' : prevState.travellerRegistrationErrors.password.message,
          },
          confirmPassword: key === 'confirmPassword' ? '' : prevState.travellerRegistrationErrors.confirmPassword,
        },
      }));
      return;
    }
    if (key === "country") {
      let reqdata = {
        country_name: val?.contry_name,
      };
      getStateApi(reqdata).then((res) => {
        let stateData = [];
        if (res && res.data && res.data.length > 0) {
          res?.data.map((item) => {
            stateData.push({
              id: item.state_code,
              label: item.state_name,
              value: item.state_code,
              code: item.state_code,
            });
          });
        }
        this.setState({ stateData: stateData });
      });
      if (this.state.travellerRegistration.country?.label !== val?.label) {
        this.setState((p) => ({
          ...p, travellerRegistration: { ...p.travellerRegistration, state: "", city: "" }
        }));
      }
    }
    if (key === "state") {
      let reqdata = {
        country_name:
          this.state.travellerRegistration.country?.label + "/" + val?.label,
      };
      getCityByCountry(reqdata).then((res) => {
        let cityData = [];
        if (res && res.data && res.data.length > 0) {
          res?.data.map((item) => {
            cityData.push({
              id: item.city_code,
              label: item.city_name,
              value: item.city_code,
              code: item.city_code,
            });
          });
        }
        this.setState({ citiesData: cityData });
      });
      if (this.state.travellerRegistration.state?.label !== val?.label) {
        this.setState((p) => ({
          ...p, travellerRegistration: { ...p.travellerRegistration, city: "" }
        }));
      }
    }
    this.setState((prevState) => ({
      travellerRegistration: {
        ...prevState.travellerRegistration,
        [key]: val,
      },
    }));
    this.setState((prevState) => ({
      travellerRegistrationErrors: {
        ...prevState.travellerRegistrationErrors,
        [key]: "",
      },
    }));
  };

  handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      const maxSize = 1 * 1024 * 1024;

      if (file.size > maxSize) {
        event.target.value = null;
        this.setState((prevState) => ({
          ...prevState,
          travellerRegistrationErrors: {
            ...prevState.travellerRegistrationErrors,
            photo: "Image size should not exceed 1 MB.",
          },
        }));
        return;
      } else {
        // Set filename immediately when file is selected
        this.setState((prevState) => ({
          travellerRegistration: {
            ...prevState.travellerRegistration,
            photoFileName: file.name,
          },
        }));

        const form = new FormData();
        form.append("file", file);

        let { data } = await axios.post(`/api/upload/profilepic`, form);
        if (data && data.data && data.data.file_path) {
          let newData = data.data.file_path;
          this.setState((prevState) => ({
            travellerRegistration: {
              ...prevState.travellerRegistration,
              photo: newData,
              photoFileName: file.name,
            },
            travellerRegistrationErrors: {
              ...prevState.travellerRegistrationErrors,
              photo: "",
            },
          }));
        }
      }
    }
    // if (file) {
    //   this.setState((prevState) => ({
    //     travellerRegistration: {
    //       ...prevState.travellerRegistration,
    //       photo: file,
    //     },
    //   }));
    // }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { travellerRegistration } = this.state;
    const errors = {};
    if (!travellerRegistration.title) {
      errors.title = "Select Title";
    }
    if (!travellerRegistration.first_name) {
      errors.first_name = "Please enter First Name";
    } else if (travellerRegistration.first_name.length < 2) {
      errors.first_name = "Name must be at least 2 characters long.";
    }
    if (!travellerRegistration.last_name) {
      errors.last_name = "Please enter Last Name";
    } else if (travellerRegistration.last_name.length < 2) {
      errors.last_name = "Name must be at least 2 characters long.";
    }
    if (!travellerRegistration.email) {
      errors.email = "Please enter Email ID";
    } else if (!emailValidation.test(travellerRegistration.email)) {
      errors.email = "Please enter valid Email ID.";
    }
    if (!travellerRegistration.country_code || !travellerRegistration.country_code.contry_isd || travellerRegistration.country_code.contry_isd === "") {
      errors.country_code = "Please select Country Code";
    }
    if (!travellerRegistration.mobile_number) {
      errors.mobile_number = "Please enter Mobile Number";
    } else if (
      travellerRegistration.mobile_number.length < 7 ||
      travellerRegistration.mobile_number.length > 16
    ) {
      errors.mobile_number = "Please enter valid Mobile Number";
    }
    if (!travellerRegistration.country) {
      errors.country = "Please select Country";
    }
    if (!travellerRegistration.state) {
      errors.state = "Please select State";
    }
    if (!travellerRegistration.city) {
      errors.city = "Please select City";
    }
    if (!travellerRegistration.gender) {
      errors.gender = "Please select Gender";
    }
    if (!travellerRegistration.password) {
      errors.password = {
        message: "Please enter Password",
        passLength: false,
        specialChar: false,
        number: false,
        upperCase: false,
        lowerCase: false,
      };
    } else {
      const password = travellerRegistration.password;

      const passwordPass = {
        passLength: password.length >= 8 && password.length <= 20,
        specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        number: /\d/.test(password),
        upperCase: /[A-Z]/.test(password),
        lowerCase: /[a-z]/.test(password),
      };
      if (Object.values(passwordPass).includes(false)) {
        errors.password = {
          ...passwordPass,
          message: "",
        };
      }
    }
    if (!travellerRegistration.confirmPassword) {
      errors.confirmPassword = "Please enter Confirm Password.";
    }
    if (
      travellerRegistration.confirmPassword &&
      travellerRegistration.confirmPassword !== travellerRegistration.password
    ) {
      errors.passMatch = "Passwords do not match";
    }
    if (!travellerRegistration.accept_terms) {
      errors.accept_terms = "You must accept the Terms and Conditions.";
    }
    // if (!travellerRegistration.photo || travellerRegistration.photo === null) {
    //   errors.photo = "";
    // }
    if (Object.keys(errors).length > 0) {
      this.setState({
        travellerRegistrationErrors: {
          ...errors,
          password: {
            passLength: errors.password?.passLength ?? true,
            specialChar: errors.password?.specialChar ?? true,
            number: errors.password?.number ?? true,
            upperCase: errors.password?.upperCase ?? true,
            lowerCase: errors.password?.lowerCase ?? true,
            message: errors.password?.message || "",
          },
        },
      }, () => {
        // Scroll to top of form container when errors occur
        if (this.formContainerRef.current) {
          // Try multiple scroll methods for better compatibility
          const element = this.formContainerRef.current;
          
          // Method 1: Scroll the element itself to top
          element.scrollTop = 0;
          
          // Method 2: Scroll parent container if it exists
          const parentScrollable = element.closest('.register_modal, [class*="register_modal"]');
          if (parentScrollable) {
            parentScrollable.scrollTop = 0;
          }
          
          // Method 3: Use scrollIntoView as fallback
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start',
            inline: 'nearest'
          });
        }
      });

      return;
    }
    const { confirmPassword, photo, photoFileName, ...rest } = travellerRegistration;
    // Encrypt password before sending
    const encryptedPassword = encryptData(rest.password);
    
    const payload = {
      ...rest,
      password: encryptedPassword,
      country: {
        value: this.state.travellerRegistration?.country?.value,
        countryFlag: this.state.travellerRegistration?.country?.countryFlag,
        countryName: this.state.travellerRegistration?.country?.label,
      },
      state: {
        code: this.state.travellerRegistration?.state?.id,
        name: this.state.travellerRegistration?.state?.label,
      },
      city: {
        code: this.state.travellerRegistration?.city?.id,
        name: this.state.travellerRegistration?.city?.label,
      },
      country_code: {
        value: this.state.travellerRegistration?.country_code?.contry_name,
        countryFlag:
          this.state.travellerRegistration?.country_code?.contry_flag,
        countryName:
          this.state.travellerRegistration?.country_code?.contry_name,
        isdCode: this.state.travellerRegistration?.country_code?.contry_isd,
        countryCode:
          this.state.travellerRegistration?.country_code?.contry_code,
        flag: this.state.travellerRegistration?.country_code?.contry_flag,
      },
      gender: this.state.travellerRegistration.gender?.value.toLowerCase(),
      site_id: this.state.site_id,
      rg_type: "customer",
      profile_image: photo,
    };
    this.setState({ isLoading: true });
    travellerSignup(payload).then((response) => {
      console.log('Full API Response:', response);
      console.log('Response data:', response?.data);
      
      if (response?.data?.registration_token) {
        // Since API doesn't return expiry time, use default 30 seconds
        const defaultExpiryTime = 30000; // 30 seconds in milliseconds
        
        const mobileOtpTime = response?.data?.mobile_otp?.otp_expiry_time;
        const emailOtpTime = response?.data?.email_otp?.otp_expiry_time;
        
        // Use default time if API doesn't provide it
        let mobileTime = defaultExpiryTime;
        let emailTime = defaultExpiryTime;
        
        // If API provides time, convert it (check if it's in seconds)
        if (mobileOtpTime) {
          mobileTime = mobileOtpTime < 10000 ? mobileOtpTime * 1000 : mobileOtpTime;
        }
        if (emailOtpTime) {
          emailTime = emailOtpTime < 10000 ? emailOtpTime * 1000 : emailOtpTime;
        }
        
        console.log('Using mobileTime:', mobileTime);
        console.log('Using emailTime:', emailTime);
        
        this.setState({
          travellerRegistrationErrors: {
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            dob: "",
            country: "",
            state: "",
            city: "",
            password: {
              passLength: true,
              specialChar: true,
              number: true,
              upperCase: true,
              lowerCase: true,
              message: "",
            },
            confirmPassword: "",
            title: "",
            photo: null,
            termsAccepted: "",
          },
          verification: true,
          registration_token: response?.data?.registration_token,
          mobileTime: mobileTime,
          emailTime: emailTime,
          user_id: response?.data?.user_id,
          isLoading: false,
          commonError: "",
        });
      } else {
        this.setState({
          commonError: response?.error?.details || "Something went wrong",
        });
        this.setState({ isLoading: false });
      }
    });
  };

  togglePassword = (id) => {
    const input = document.getElementById(id);
    if (input) {
      input.type = input.type === "password" ? "text" : "password";
    }
  };

  Success() {
    let styles = this.props.styles;
    return (
      <div className={styles?.verification_modal}>
        <div className={styles?.verification_main_content}>
          <div className={styles?.success_form}>
            <div className={styles?.success_container}>
              <img
                src="images/check_circle.svg"
                alt="Success Icon"
                className={styles?.success_icon}
              />
              <div>
                <h2 className={styles?.success_title}>
                  Thank you for registering with tripbutter!
                </h2>
                <p className={styles?.success_message}>
                  Thank you for registering with us! We're excited to have you
                  on board and look forward to providing you with the best
                  experience possible.
                </p>
              </div>
              <button
                className={styles?.register_btn}
                onClick={() => [
                  this.setState({
                    registerSuccess: false,
                    verification: false,
                  }),
                  this.props.openLoginPopup(),
                ]}
              >
                <span>Login Now</span>
                <img src="images/button_arrow.svg" alt="Arrow Right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleTnc = (e) => {
    e.stopPropagation(), this.setState({ tnc: true });
  };

  TermsCondition() {
    let styles = this.props.styles;
    return (
      <div className={styles?.terms_condn_modal}>
        {/* <img
          src="/images/tb_arrow_left.svg"
          alt="back"
          className={styles.back_arrow_terms}
          onClick={this.handleBack}
        /> */}
        {this.state.isMobile && (
          <div className={styles.term_mob_header}>
            <div className={styles.term_icon}>
              <img src="/images/te_black_Left_Arrow.svg" alt="arrow" />
            </div>
            <h2 className={styles.term_title}>Terms &amp; Conditions</h2>
          </div>
        )}
        <div className={styles?.terms_condn_content}>
          <div className={styles?.terms_condn_container}>
            {!this.state.isMobile && (
              <h2
                className={styles?.terms_condn_title}
                onClick={(e) => {
                  e.stopPropagation(), this.setState({ tnc: false });
                }}
              >
                Terms and Conditions
              </h2>
            )}
            <p>
              Terms and conditions content goes here. Please read carefully
              before proceeding.
            </p>

            <p>
              Terms and conditions content goes here. Please read carefully
              before proceeding.
            </p>
          </div>
        </div>
      </div>
    );
  }

  handleBack = () => {
    if (this.state.verification) {
      this.setState({ verification: false });
    } else if (this.state.tnc) {
      this.setState({ tnc: false });
    } else {
      this.props.data.onClickCross();
    }
  };

  handleKeyDown = (e) => {
    e.preventDefault();
  };

  clearOtpInputs = (state) => {
    this.setState({ [state]: Array(6).fill("") });
  };

  openCalendar = () => {
    if (this.dateInputRef.current) {
      this.dateInputRef.current.click();
    }
  };

  render() {
    let styles = this.props.styles;
    let dropdownStyle = this.props.dropDownStyles;
    let titledropdownStyles = this.props.titledropdownStyles;
    let isdDropdownStyles = this.props.isdDropdownStyles;
    let datepickerStyles = this.props.datepicker;
    const banners = this.props?.data?.siteData?.data?.signin?.banners;
    const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18));

    const imageLoader = ({ src }) => {
      const url = `/shared/api/media/${src}`;
      return url;
    };
    const customResponsive = {
      desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
      tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
        slidesToSlide: 2,
      },
      mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
    };
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 100;
    const maxYear = currentYear;
    const minDateStr = `${minYear}-01-01`;
    const maxDateStr = `${maxYear}-12-31`;

    return (
      <>
        {this.state.isMobile && (
          <div className={styles?.login_banner}>
            <CustomCarousel
              banners={banners}
              imageLoader={imageLoader}
              cssstyles={this.props.PromotionBannerCss}
              arrows={false}
              dots={true}
              autoplay={false}
              imageKey="upload_image" // Default image key, can be adjusted
              prevArrow={"/images/back-arrow.png"}
              nextArrow={"/images/back-arrow.png"}
              responsive={customResponsive}
            />
            <div
              className={styles?.banner_left_arrrow}
              onClick={this.handleBack}
            >
              <img src="images/te_Left_Arrow.svg" alt="arrow" />
            </div>
          </div>
        )}
        {!this.state.verification && !this.state.tnc ? (
          <div className={styles?.register_modal}>
            <div className={styles?.main_content}>
              <div className={styles?.registration_form}>
                <div className={styles?.form_container} ref={this.formContainerRef}>
                  <div className={styles?.form_header}>
                    <h1 className={styles?.registraion_title}>
                      Welcome to tripbutter!
                    </h1>
                    <p>
                      Please fill out the form to complete your registration.
                    </p>
                  </div>
                  <div className={styles?.form_divider} />

                  {this.state.travellerRegistrationErrors.passMatch && (
                    <div className={styles?.password_error_wrapper}>
                      <span className={styles?.password_error}>
                        <img
                          src="images/password_error.svg"
                          alt="Error Icon"
                          className={styles?.error_icon}
                        />
                        {this.state.travellerRegistrationErrors.passMatch}
                      </span>
                    </div>
                  )}

                  <form className={styles?.registration_fields}>
                    {/* Row 1: Name Fields */}
                    <div className={styles?.form_row}>
                      <div className={styles?.form_group}>
                        <label htmlFor="firstName">
                          First Name <span className={styles?.required}>*</span>
                        </label>
                        <div className={styles?.name_input_container}>
                          <div className={styles?.title_dropdown}>
                            <Dropdown
                              options={[
                                { id: "Mr", label: "Mr." },
                                { id: "Mrs", label: "Mrs." },
                                { id: "Ms", label: "Ms." },
                              ]}
                              placeholder="Title"
                              showCrossIcon={true}
                              label=""
                              showLabel={true}
                              onChange={(selectedOption) =>
                                this.handleChange("title", selectedOption?.id)
                              }
                              showSearch={false}
                              styles={titledropdownStyles}
                              value={this.state.travellerRegistration.title}
                              error={
                                this.state.travellerRegistrationErrors.title
                              }
                            />
                          </div>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            placeholder="Enter your first name"
                            className={` ${this.state.travellerRegistrationErrors.first_name
                              ? styles?.error_input
                              : ""
                              }
                              ${styles?.name_input}`}
                            onChange={(e) =>
                              this.handleChange("first_name", e.target.value)
                            }
                            value={this.state.travellerRegistration.first_name}
                            maxLength={50}
                          />
                        </div>
                        <div className={styles?.flex_error_message}>
                          {this.state.travellerRegistrationErrors.title && (
                            <div className={styles?.error_message}>
                              {this.state.travellerRegistrationErrors.title}
                            </div>
                          )}
                          {this.state.travellerRegistrationErrors
                            .first_name && (
                              <div className={styles?.error_message}>
                                {
                                  this.state.travellerRegistrationErrors
                                    .first_name
                                }
                              </div>
                            )}
                        </div>
                      </div>

                      <div className={styles?.form_group}>
                        <label htmlFor="lastName">
                          Last Name <span className={styles?.required}>*</span>
                        </label>
                        <input
                          type="text"
                          id="lastName"
                          name="lastName"
                          placeholder="Enter your last name"
                          className={`${this.state.travellerRegistrationErrors.last_name
                            ? styles?.error_input
                            : ""
                            }`}
                          onChange={(e) =>
                            this.handleChange("last_name", e.target.value)
                          }
                          value={this.state.travellerRegistration.last_name}
                          maxLength={50}
                        />
                        {this.state.travellerRegistrationErrors.last_name && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.last_name}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Row 2: Email and Mobile */}
                    <div className={styles?.form_row}>
                      <div className={styles?.form_group}>
                        <label htmlFor="email">
                          Email <span className={styles?.required}>*</span>
                        </label>
                        <input
                          type="text"
                          id="email"
                          name="email"
                          placeholder="Enter your email id"
                          className={`${this.state.travellerRegistrationErrors.email
                            ? styles?.error_input
                            : ""
                            }`}
                          onChange={(e) =>
                            this.handleChange("email", e.target.value)
                          }
                          value={this.state.travellerRegistration.email}
                        />

                        {this.state.travellerRegistrationErrors.email && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.email}
                          </div>
                        )}
                      </div>

                      <div className={styles?.form_group}>
                        <label htmlFor="mobile">
                          Mobile <span className={styles?.required}>*</span>
                        </label>
                        <div className={styles?.mobile_input_container}>
                          <div className={styles?.country_code}>
                            <IsdCodeDropdown
                              onSelect={(selectedOption) =>
                                this.handleChange(
                                  "country_code",
                                  selectedOption
                                )
                              }
                              styles={isdDropdownStyles}
                              value={"+91"}
                            />
                         
                          </div>
                          <input
                            type="tel"
                            id="mobile"
                            name="mobile"
                            placeholder="Mobile number"
                            className={`${this.state.travellerRegistrationErrors
                              .mobile_number
                              ? styles?.error_input
                              : ""
                              } ${styles?.name_input}`}
                            onChange={(e) =>
                              this.handleChange("mobile_number", e.target.value)
                            }
                            value={
                              this.state.travellerRegistration.mobile_number
                            }
                            maxLength={16}
                          />
                        </div>
                        {this.state.travellerRegistrationErrors
                          .mobile_number && (
                            <div className={styles?.error_message}>
                              {
                                this.state.travellerRegistrationErrors
                                  .mobile_number
                              }
                                 {this.state.travellerRegistrationErrors.country_code && (
                              <div className={styles?.error_message}>
                                {this.state.travellerRegistrationErrors.country_code}
                              </div>
                            )}
                            </div>
                          )}
                      </div>
                    </div>

                    {/* Row 3: DOB and Photo */}
                    <div className={styles?.form_row}>
                      <div className={styles?.form_group}>
                        <label htmlFor="dob">Date of Birth</label>
                        <div>
                          <DatePicker
                            styles={styles}
                            onChange={(date) => this.handleChange("dob", date)}
                            maxDate={maxDate}
                            value={this.state.travellerRegistration.dob}
                          />
                        </div>
                        {this.state.travellerRegistrationErrors.dob && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.dob}
                          </div>
                        )}
                      </div>
                      <div className={`${styles?.form_row} ${styles?.form_gender_row}`}>
                        <div className={styles?.form_group}>
                          <div className={styles?.select_container}>
                            <label htmlFor="dob">Gender  <span className={styles?.required}>*</span></label>
                            <Dropdown
                              options={[{label:'Male',value:'Male',id:'Male'}, {label:'Female', value:'Female',id:'Female'}, {label:'Other', value:'Other', id:'Other'}]}
                              placeholder="Select Gender"
                              showCrossIcon={true}
                              label=""
                              showLabel={false}
                              onChange={(selectedOption) =>
                                this.handleChange("gender", selectedOption)
                              }
                              styles={dropdownStyle}
                              error={
                              this.state.travellerRegistrationErrors.gender
                            }
                              value={this.state.travellerRegistration.gender}
                        />
                          </div>
                          {this.state.travellerRegistrationErrors.gender && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.gender}
                          </div>
                        )}
                        </div>
                        
                      </div>
                    </div>
                    <div className={styles?.form_row}>
                      <div className={styles?.form_group}>
                        <label htmlFor="photo">Upload Profile Photo</label>
                        <div className={styles?.photo_input_container}>
                          <input
                            type="file"
                            id="photo"
                            name="photo"
                            className={styles?.photo_input}
                            accept="image/jpeg,image/png,image/jpg,image/webp"
                            onChange={this.handleFileChange}
                          />
                          <span className={styles?.upload_placeholder}>
                            {this.state.travellerRegistration.photoFileName
                              ? this.state.travellerRegistration.photoFileName
                              : "Upload Photo"}
                          </span>
                          <span className={styles?.browse}>Browse</span>
                        </div>
                        <p className={styles?.photo_note}>
                          Image format: JPG, JPEG, WEBP or PNG. Size: 1MB Max
                        </p>
                        {this.state.travellerRegistrationErrors.photo && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.photo}
                          </div>
                        )}
                      </div>
                        <div className={styles?.form_group}>
                        <div className={styles?.select_container}>
                          <Dropdown
                            options={this.state.originCountries}
                            placeholder="Country"
                            showCrossIcon={true}
                            label="Country"
                            showLabel={true}
                            onChange={(selectedOption) =>
                              this.handleChange("country", selectedOption)
                            }
                            required
                            styles={dropdownStyle}
                            error={
                              this.state.travellerRegistrationErrors.country
                            }
                            value={this.state.travellerRegistration.country}
                          />
                        </div>
                        {this.state.travellerRegistrationErrors.country && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.country}
                          </div>
                        )}
                      </div>
                      </div>
                    {/* Row 4: Country and State */}
                    <div className={styles?.form_row}>
                    
                      <div className={styles?.form_group}>
                        <div className={styles?.select_container}>
                          <Dropdown
                            options={this.state.stateData}
                            placeholder="Select State"
                            showCrossIcon={true}
                            label="State"
                            showLabel={true}
                            onChange={(selectedOption) =>
                              this.handleChange("state", selectedOption)
                            }
                            required
                            styles={dropdownStyle}
                            error={this.state.travellerRegistrationErrors.state}
                            value={this.state.travellerRegistration.state}
                          />
                        </div>
                        {this.state.travellerRegistrationErrors.state && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.state}
                          </div>
                        )}
                      </div>
                       <div
                        className={`${styles?.form_group} ${styles?.city_group}`}
                      >
                        <div className={styles?.select_container}>
                          <Dropdown
                            options={this.state.citiesData}
                            placeholder="City"
                            showCrossIcon={true}
                            label="City"
                            showLabel={true}
                            onChange={(selectedOption) =>
                              this.handleChange("city", selectedOption)
                            }
                            required
                            styles={dropdownStyle}
                            error={this.state.travellerRegistrationErrors.city}
                            value={this.state.travellerRegistration.city}
                          />
                        </div>
                        {this.state.travellerRegistrationErrors.city && (
                          <div className={styles?.error_message}>
                            {this.state.travellerRegistrationErrors.city}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Row 5: City */}
                    <div className={styles?.form_row}>
                     
                    </div>

                    {/* Row 6: Password */}
                    <div className={styles?.form_row}>
                      <div className={styles?.form_group}>
                        <label htmlFor="password">
                          Password <span className={styles?.required}>*</span>
                        </label>
                        <div className={styles?.password_container}>
                          <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            onChange={(e) =>
                              this.handleChange("password", e.target.value)
                            }
                            className={`${this.state.travellerRegistrationErrors?.password
                              ?.message
                              ? styles?.error_input
                              : ""
                              }`}
                            value={this.state.travellerRegistration.password}
                          />
                          <button
                            type="button"
                            className={styles?.toggle_password}
                            onClick={() => this.togglePassword("password")}
                          >
                            <img
                    src={
                      document.getElementById("password")?.type === "password"
                        ? "images/te_Eye_off.svg"
                        : "images/te_Eye.svg"
                    }
                    alt="Toggle Password"
                  />
                          </button>
                        </div>
                        {this.state.travellerRegistrationErrors.password
                          ?.message && (
                            <div className={styles?.error_message}>
                              {
                                this.state.travellerRegistrationErrors.password
                                  ?.message
                              }
                            </div>
                          )}
                      </div>

                      <div className={styles?.form_group}>
                        <label htmlFor="confirmPassword">
                          Confirm Password{" "}
                          <span className={styles?.required}>*</span>
                        </label>
                        <div className={styles?.password_container}>
                          <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Enter your password again"
                            className={`${this.state.travellerRegistrationErrors
                              .confirmPassword
                              ? styles?.error_input
                              : ""
                              }`}
                            onChange={(e) =>
                              this.handleChange(
                                "confirmPassword",
                                e.target.value
                              )
                            }
                            value={
                              this.state.travellerRegistration.confirmPassword
                            }
                          />
                          <button
                            type="button"
                            className={styles?.toggle_password}
                            onClick={() =>
                              this.togglePassword("confirmPassword")
                            }
                          >
<img
                    src={
                      document.getElementById("confirmPassword")?.type === "password"
                        ? "images/te_Eye_off.svg"
                        : "images/te_Eye.svg"
                    }
                    alt="Toggle Password"
                  />
                          </button>
                        </div>
                        {this.state.travellerRegistrationErrors
                          .confirmPassword && (
                            <div className={styles?.error_message}>
                              {
                                this.state.travellerRegistrationErrors
                                  .confirmPassword
                              }
                            </div>
                          )}
                      </div>
                    </div>

                    {/* Password Rules */}
                    <div className={styles?.password_requirements}>
                      <p>Password must contain at least</p>
                      <ul>
                        <li>
                          <span
                            className={` ${this.state.travellerRegistrationErrors.password
                              ?.passLength
                              ? styles?.bullet
                              : styles?.errorDot
                              }`}
                          >
                            &bull;
                          </span>{" "}
                          Between 8 to 20 characters
                        </li>
                        <li>
                          <span
                            className={`${this.state.travellerRegistrationErrors.password
                              ?.upperCase
                              ? styles?.bullet
                              : styles?.errorDot
                              }`}
                          >
                            &bull;
                          </span>{" "}
                          One uppercase letter
                        </li>
                        <li>
                          <span
                            className={`${this.state.travellerRegistrationErrors.password
                              ?.number
                              ? styles?.bullet
                              : styles?.errorDot
                              }`}
                          >
                            &bull;
                          </span>{" "}
                          One or more numbers
                        </li>
                        <li>
                          <span
                            className={`${this.state.travellerRegistrationErrors.password
                              ?.specialChar
                              ? styles?.bullet
                              : styles?.errorDot
                              }`}
                          >
                            &bull;
                          </span>{" "}
                          One or more special characters
                        </li>
                      </ul>
                    </div>

                    {/* Terms */}
                    <div className={styles?.terms_container}>
                      <div className={styles?.checkbox_terms_condition_wrapper}>
                        <label
                          className={styles?.checkbox_container}
                        // htmlFor="terms"
                        >
                          <input
                            type="checkbox"
                            id="terms"
                            name="terms"
                            checked={
                              this.state.travellerRegistration.accept_terms
                            }
                            onChange={(e) => [
                              e.stopPropagation(),
                              this.handleChange(
                                "accept_terms",
                                !this.state.travellerRegistration.accept_terms
                              ),
                            ]}
                          />
                          <span className={styles?.checkbox_text}>
                            I have read, understood and accepted the{" "}
                            <a
                              href="#"
                              className={styles?.terms_link}
                              onClick={(e) => this.handleTnc(e)}
                            >
                              Terms and Conditions
                            </a>
                          </span>
                        </label>
                      </div>

                      {this.state.travellerRegistrationErrors.accept_terms && (
                        <div className={styles?.error_message}>
                          {this.state.travellerRegistrationErrors.accept_terms}
                        </div>
                      )}
                      {this.state.commonError && (
                        <div className={styles?.error_message}>
                          {this.state.commonError}
                        </div>
                      )}
                    </div>

                    {/* Submit */}
                    <div className={styles?.submit_container}>
                      <button
                        type="submit"
                        className={`${styles?.register_btn} ${this.state.isLoading ? "loading" : ""
                          }`}
                        onClick={this.handleSubmit}
                      >
                        <span>Register Now</span>
                        <img src="images/button_arrow.svg" alt="Arrow Right" />
                      </button>

                      <div className={styles?.login_links}>
                        <p onClick={this.props.openLoginPopup}>
                          <span>Already Registered?</span>
                          <a className={styles?.login_link}>Login Now</a>
                        </p>
                        <p>
                          <span>Do you want </span>
                          <span className={styles?.tour_master}>
                            Become a Tour Master
                          </span>
                          <span>? </span>
                          <a
                            href="/registration"
                            className={styles?.tour_master_link}
                          >
                            Click Here
                          </a>
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : this.state.registerSuccess ? (
          this.Success()
        ) : this.state.tnc ? (
          this.TermsCondition()
        ) : (
          <Verification
            email={this.state.travellerRegistration.email || ""}
            number={this.state.travellerRegistration.mobile_number || ""}
            site_id={this.state.site_id}
            registration_token={this.state.registration_token}
            user_id={this.state.user_id}
            onSuccess={() => this.setState({ registerSuccess: true })}
            mobileOtpChange={this.mobileOtpChange}
            emailOtpChange={this.emailOtpChange}
            handleBack={this.handleBack}
            mobileOtp={this.state.mobileOtp}
            emailOtp={this.state.emailOtp}
            styles={styles}
            mobileTimeFormatted={this.formatTime(this.state.mobileTime)}
            emailTimeFormatted={this.formatTime(this.state.emailTime)}
            setMobileTime={this.setMobileTime}
            setEmailTime={this.setEmailTime}
            setCommonError={this.setCommonError}
            commonError={this.state.commonError}
            loading={this.state.loading}
            setLoading={this.setVerificationLoading}
            clearOtpInputs={this.clearOtpInputs}
          />
        )}
      </>
    );
  }
}

export default RegisterForm;